import { api } from '@api/api2';

export const getList = () => api.v1('get', 'enterprises/admin/confirmation-modes');
